module.exports = __webpack_public_path__ + "static/media/Hampsted road 3.9909119b.jpg";